import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { PhoneIcon, ClipboardListIcon } from 'lucide-react';
import { useEstimate } from '../contexts/EstimateContext';
import { business, trustBadges } from '../data/content';
const heroBackground = 'https://cdn.magicpatterns.com/uploads/8ANEZ3mJffuKrEUh4zwNjn/dany1.png';
export function Hero() {
  const reduce = useReducedMotion();
  const {
    openEstimate
  } = useEstimate();
  return <section id="top" className="relative isolate overflow-hidden bg-forest-dark" data-id="element-174" data-mp="128pi5dka8x4k">
      <img src={heroBackground} alt="" aria-hidden="true" className="absolute inset-0 -z-20 h-full w-full object-cover object-[center_65%]" data-id="element-175" data-mp="xbpbb0flzqce" />
      <div className="absolute inset-0 -z-10 bg-forest-dark/70 lg:bg-transparent" aria-hidden="true" data-id="element-176" data-mp="nc88cqrqrqk4" />
      <div className="absolute inset-0 -z-10 hidden lg:block" style={{
      background: 'linear-gradient(90deg, rgba(18,50,29,0.92) 0%, rgba(18,50,29,0.78) 45%, rgba(18,50,29,0.25) 100%)'
    }} aria-hidden="true" data-id="element-177" data-mp="3d1imxgffvoql" />

      <div className="mx-auto grid min-h-[640px] max-w-7xl items-center gap-10 px-5 py-16 md:px-8 lg:min-h-[720px] lg:grid-cols-[1.15fr_0.85fr] lg:gap-16 lg:py-24" data-id="element-178" data-mp="3j7zgfm2d3yi9">
        <motion.div initial={reduce ? false : {
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-179" data-mp="3o59d9ms2zcg4">
          <h1 className="font-display text-4xl font-bold leading-[1.1] text-white sm:text-5xl lg:text-6xl" data-id="element-180" data-mp="30iaz4vrfogld">
            Your Yard Can Look Show-Ready in 48 Hours — Without You Doing a Thing
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/85" data-id="element-181" data-mp="2qkdc2blb8puc">
            Stone work and landscaping across North Dallas. Free estimates, honest prices.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-182" data-mp="2hj5clq725iyo">
            <button type="button" onClick={() => openEstimate()} className="inline-flex items-center justify-center gap-2.5 whitespace-nowrap rounded-md bg-brick px-7 py-4 text-base font-semibold text-white shadow-sm transition-[background-color,transform] duration-150 ease-out hover:bg-brick-dark active:scale-[0.98] md:text-lg" data-id="element-183" data-mp="2hl9q8zurdwc5">
              <ClipboardListIcon className="h-5 w-5" aria-hidden="true" data-id="element-184" data-mp="iboyiltrcouw" />
              Get a Free Estimate
            </button>
            <a href={business.phoneHref} className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/40 px-7 py-4 text-base font-semibold text-white transition-colors duration-150 hover:border-white hover:bg-white/10" data-id="element-185" data-mp="degesgsyocrj">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-186" data-mp="112g89ohnqh9t" />
              Call {business.phoneDisplay}
            </a>
          </div>
          <ul className="mt-10 flex flex-wrap gap-x-6 gap-y-3 border-t border-white/20 pt-6" data-id="element-187" data-mp="x0cu2s3lsyku">
            {trustBadges.map(({
            label,
            icon: Icon
          }) => <li key={label} className="flex items-center gap-2 text-sm font-medium text-white" data-id="element-188" data-mp="3hr3s5wvh8d6c">
                <Icon className="h-4 w-4 text-[#9fd67a]" aria-hidden="true" data-id="element-189" data-mp="1xa429a5swchi" />
                {label}
              </li>)}
          </ul>
        </motion.div>

        <div className="hidden lg:flex lg:justify-end lg:self-end" data-id="element-190" data-mp="218tkph5p4k80">
          <div className="w-80 rounded-xl bg-white p-6 shadow-2xl" data-id="element-191" data-mp="2697ogn09l808">
            <p className="text-sm font-medium text-ink-muted" data-id="element-192" data-mp="2b192oegzt8sw">Free estimate, no obligation</p>
            <a href={business.phoneHref} className="mt-2 flex items-center gap-2 font-display text-3xl font-bold text-forest hover:text-forest-light" data-id="element-193" data-mp="2g0c1viaakksy">
              <PhoneIcon className="h-6 w-6 text-brick" aria-hidden="true" data-id="element-194" data-mp="2kx2hy5m3jged" />
              {business.phoneDisplay}
            </a>
            <p className="mt-3 text-sm leading-relaxed text-ink-muted" data-id="element-195" data-mp="2tzljmme5bmz1">
              We come out, assess your property, and give you an honest price.
            </p>
            <button type="button" onClick={() => openEstimate()} className="mt-4 text-sm font-semibold text-brick hover:text-brick-dark" data-id="element-196" data-mp="uoak1pprb1vt">
              Or request it online →
            </button>
          </div>
        </div>
      </div>
    </section>;
}